import { Component, Inject, OnInit, Optional } from "@angular/core";
import { PlatformService } from "@src/app/servicios/platform/platform.service";
import { RESPONSE } from "@src/express.tokens";
import { Response } from "express";
import { DEFAULT_404_IMAGE } from "@src/constants/default-404-image";
import { ConfigService } from "@src/app/servicios/config/config.service";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.css"],
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  imagen;
  constructor(
    private configService: ConfigService,
    @Optional() @Inject(RESPONSE) private response: Response,
    private platformService: PlatformService,
  ) {
    if (this.response && !this.platformService.isBrowser()) {
      this.response.status(404);
    }
  }

  ngOnInit(): void {
    const constantesGlobales = this.configService.getConstantesGlobales();
    this.imagen = constantesGlobales?.["imagen404"] || DEFAULT_404_IMAGE;
  }

  onImageError(): void {
    this.imagen = DEFAULT_404_IMAGE; // Si falla, usamos la imagen por defecto en Base64
  }
}
